'use strict';

const iframe = {
    init: function () {
        let blockIframe = document.querySelector('.block__iframe');
        if(blockIframe) {
            if(window.matchMedia("(max-width: 767px)").matches) {
                blockIframe.height = blockIframe.dataset.mobileheight;
            } else {
                blockIframe.height = blockIframe.dataset.desktopheight;
            }
        }
    }
};

export default iframe;


// WEBPACK FOOTER //
// ./src/scripts/components/iframe.js